import { SupportTicket } from '@/hooks/useSupportTickets';
import { SupportTicketCard } from './SupportTicketCard';
import { Skeleton } from '@/components/ui/skeleton';

interface SupportTicketListProps {
  tickets: SupportTicket[] | undefined;
  isLoading: boolean;
  onTicketClick: (ticketId: string) => void;
}

export const SupportTicketList = ({ tickets, isLoading, onTicketClick }: SupportTicketListProps) => {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {[...Array(3)].map((_, i) => (
          <Skeleton key={i} className="h-32 w-full rounded-lg" />
        ))}
      </div>
    );
  }

  if (!tickets || tickets.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      {tickets.map((ticket) => (
        <SupportTicketCard
          key={ticket.id}
          ticket={ticket}
          onClick={() => onTicketClick(ticket.id)}
        />
      ))}
    </div>
  );
};
